import React from 'react';
import { useNavigate } from 'react-router-dom';

import { Button } from '@components/common';
import Header from '@components/common/Header';

import styles from './Plug.module.scss';

const Plug = () => {
	const navigate = useNavigate();

	const onBackClickHandler = () => navigate(-1);

	return (
		<div className={styles.plugContainer}>
			<Header />
			<div className={styles.backButtonWrapper}>
				<div className={styles.title}>
					Oops!
				</div>
				<div className={styles.subtitle}>
					Something went wrong...
				</div>
				<Button
					onClick={onBackClickHandler}
					text='Back'
				/>
			</div>
		</div>
	);
};

export default Plug;
